export default __webpack_public_path__ + "static/3_21-1--220d225a03a84310fa14b98a58a4fe4f.png";